import type { Directive } from 'vue';
import { watch } from 'vue';

import { usePermissionStore } from '@/store/modules/permission';

export const fieldPermission: Directive = {
  mounted(el, binding) {
    const permissionStore = usePermissionStore();
    const { value } = binding;

    // 先隐藏元素，而不是删除
    el.style.display = 'none';

    // 等待角色信息加载完成后再判断
    if (permissionStore.allRoleList?.length) {
      handleFieldPermission();
    } else {
      // 监听角色列表变化
      const unwatch = watch(
        () => permissionStore.allRoleList,
        (newVal) => {
          if (newVal?.length) {
            handleFieldPermission();
            unwatch(); // 清理 watch
          }
        },
      );
    }
    function handleFieldPermission() {
      // 如果是管理员，显示元素
      if (permissionStore.allRoleList?.some((role) => role.code === 'ADMIN')) {
        el.style.display = '';
        return;
      }

      // 检查具体权限 -- 包含字段权限处理， 如果字段权限都没有，则隐藏元素
      if (value && !permissionStore.hasFieldPermission(value)) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
      }
    }
  },
};
